__turbopack_context__.v({
  "panel": "SeeInActionPanel-module-scss-module__PPlYKG__panel",
  "video": "SeeInActionPanel-module-scss-module__PPlYKG__video",
});
